import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  DoCheck,
  OnInit,
} from '@angular/core'
import {
  Breadcrumb,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { Observable } from 'rxjs'
import { FacetService } from '../services/facet.service'
import { ICON_TYPE, FacetList } from '@spartacus/storefront'
import { ActivatedRoute } from '@angular/router'
import { ProductListComponentService } from '../../list/product-list-component.service'
import { PlpService } from '../../plp.service'
import { Title } from '@angular/platform-browser'

/**
 * Active facets render the applied facet values as a list of focusable buttons
 * which can be used to remove the applied facet value.
 */
@Component({
  standalone: false,

  selector: 'cx-active-facets',
  templateUrl: './active-facets.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ActiveFacetsComponent implements DoCheck, OnInit {
  /** Active facets which are applied to the product results. */
  facetList$: Observable<FacetList> = this.facetService.facetList$
  @Output() routerEmiited = new EventEmitter<string>()
  /** Configurable icon which is used for the active facet close button */
  @Input() closeIcon = ICON_TYPE.CLOSE
  url: string
  params: any

  constructor(
    protected facetService: FacetService,
    public routes: ActivatedRoute,
    public productListComponentService: ProductListComponentService,
    private plpService: PlpService,
    private titleService: Title,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.routes.params.subscribe(
      (params) => {
        this.params = params
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  getLinkParams(facet: Breadcrumb) {
    return this.facetService.getLinkParams(facet.removeQuery?.query?.value)
  }

  /**
   * The focus key is used to persist the focus on the facet when the DOM is being
   * recreated. We only apply the focus key for the given _active_ facet when there
   * the original facets is not available. This happens for non multi-valued facets.
   *
   * With this approach, the we keep the focus, either at the facet list or on the
   * active facets.
   */
  getFocusKey(facetList: FacetList, facet: Breadcrumb) {
    return facetList.facets?.find((f) =>
      f.values?.find((val) => val.name === facet.facetValueName)
    )
      ? ''
      : facet.facetValueName
  }
  ngDoCheck() {
    // tslint:disable-next-line: prefer-for-of
    this.routes.params.subscribe(
      (params) => {
        if (!params['query']) {
          this.titleService.setTitle('Products | BH ValvStore')
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    for (let i = 0; i < this.routes.snapshot.url.length; i++) {
      this.url = this.url + '/' + this.routes.snapshot.url[i]
    }
    this.routerEmiited.emit(this.url)
    this.url = ''
  }
  changePage() {
    this.productListComponentService.setPagetoDefault(50);
    if(this.params?.categoryCode)
    this.plpService.setCategoryBreadCrumbs(this.params.categoryCode);
  }
}
